import { Navigate } from 'react-router-dom'

import { UserRoleLabel } from 'src/hooks/useLogin'
import { useUser } from 'src/state/userState'

interface Props {
    allowedRoles: UserRoleLabel[]
    children?: React.ReactNode
}

const RoleRestricted = (props: Props) => {
    const { allowedRoles, children } = props

    const { info } = useUser()

    const userRoleNames = info.roles.map(({ label }) => label) || []
    const canAccess = allowedRoles.some((allowedRole) => userRoleNames.includes(allowedRole))

    if (canAccess) {
        return children
    }

    return <Navigate to={'/404'} /> // This path doesn't exist so returns not found.
}

export default RoleRestricted
